import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  IconButton
} from "@mui/material";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export default function Contact() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(form);
  };

  return (
    <Box sx={{ background: "#f7f9fc", py: 8 }}>
      <Container id="hello" maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          fontWeight="300"
          gutterBottom
        >
          Contact us
        </Typography>

        <Typography
          variant="subtitle1"
          align="center"
          color="text.secondary"
          mb={6}
        >
          We'd love to hear from you. Send us a message and we'll respond soon.
        </Typography>

        <Grid container spacing={5}>

          {/* Contact Info */}

          <Grid item xs={12} md={5} sx={{width: "100%"}}>
            <Paper sx={{ p: 4, borderRadius: 3, height: "100%", width: "100%"}}>

              <Typography variant="h5" fontWeight="300" mb={3}>
                Contact Information
              </Typography>

              <Box display="flex" alignItems="center" mb={4}>
                <EmailIcon sx={{ mr: 2 }} />
                <Typography>
                  <a href="mailto:sean@tahiteams.com">sean@tahiteams.com</a>
                </Typography>
              </Box>

              <Typography variant="h6" mb={2} fontWeight="300" >
                Follow Us
              </Typography>

              <Box sx={{display: "flex", gap: "12px"}}>
                <a
                  href="https://twitter.com/Alex53106399"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TwitterIcon />
                </a>

                <a
                  href="https://www.linkedin.com/company/stakeholders-app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon />
                </a>
              </Box>

            </Paper>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}